// extracted by css-extract-rspack-plugin
export default {"cls1":"ExpandableTable-cls1_Evx","cls2":"ExpandableTable-cls2_ANT ExpandableTable-cls1_Evx"};